module.exports = __webpack_public_path__ + "fonts/iconfont.fdb556f1.woff";